// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "acquisitionspa." + "534ce30ef52af91f2e11" + ".chunk.css";
};